import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import {
  BarcodeBookState,
  getStateName,
} from "../../../../../Constants/BarcodeBookState";
import { getReportTypeDescription, getReportTypeName } from "../../../../../Constants/ReportTypes";
import "./InfoModal.scss";

export function InfoModal({ book, ...props }) {
  const [t] = useTranslation();

  return (
    <Modal {...props} centered dialogClassName="info-modal">
      <Modal.Header closeButton>
        <span className="title">{t(getStateName(book.state))}</span>
      </Modal.Header>
      <Modal.Body className="info-modal-content">
        {book.state === BarcodeBookState.Keeped && (
          <Modal.Body className="info-modal-content">
            <span className="title">{t("KeepedSummertask")}</span>
            <span className="sub-title">
              {t("KeepedSummertaskDescription")}
            </span>
          </Modal.Body>
        )}

        {book.state === BarcodeBookState.Reported && (
          <Modal.Body className="info-modal-content">
            <span className="title">
              {t(getReportTypeName(book.reportType))}
            </span>
            <span className="sub-title">
              {t(getReportTypeDescription(book.reportType))}
            </span>
          </Modal.Body>
        )}
      </Modal.Body>
    </Modal>
  );
}
